import * as types from "../actions/actionTypes";

const initialState = {
  fileList: [],
  uploadLogs: [],
  fileDetails: {},
};

export default function manualUpload(state = initialState, action) {
  switch (action.type) {
    case types.GET_MANUAL_UPLOAD_FILES: {
      const { data } = action.payload;
      return {
        ...state,
        fileList: data,
      };
    }

    case types.GET_UPLOAD_FILES_LOGS: {
      const { data } = action.payload;
      return {
        ...state,
        uploadLogs: data,
      };
    }

    case types.GET_UPLOADED_FILE_SAS: {
      const { data } = action.payload;

      return {
        ...state,
        fileDetails: { filePath: data },
      };
    }
      
    default:
      return state;
  }
}
